"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnIndexByCursorPosition = void 0;
function getColumnIndexByCursorPosition({ cursorLeftOffset, currentIndex, columnsOffsets, edgeColumnOffset, startIndexLimit, endIndexLimit }) {
    const limitCursorLeftOffset = Math.min(Math.max(cursorLeftOffset, 0), edgeColumnOffset);
    let result = currentIndex || 0;
    for (let i = 0; i < columnsOffsets.length; i++) {
        const params = columnsOffsets[i];
        if (limitCursorLeftOffset === 0) {
            result = 0;
            break;
        }
        if (limitCursorLeftOffset === edgeColumnOffset) {
            result = columnsOffsets.length - 1;
            break;
        }
        if (limitCursorLeftOffset <= params.leftOffset ||
            limitCursorLeftOffset > params.rightOffset) {
            continue;
        }
        if (typeof currentIndex === 'undefined') {
            result = i;
            break;
        }
        if (i === currentIndex) {
            result = i;
            break;
        }
        if (i < currentIndex) {
            result = limitCursorLeftOffset <= columnsOffsets[i].equator ? i : i + 1;
            break;
        }
        result = limitCursorLeftOffset <= columnsOffsets[i].equator ? i - 1 : i;
        break;
    }
    return Math.min(Math.max(result, startIndexLimit), endIndexLimit);
}
exports.getColumnIndexByCursorPosition = getColumnIndexByCursorPosition;
//# sourceMappingURL=getColumnIndexByCursorPosition.js.map